import React, { useContext } from "react";
import moment from "moment";
import "../../styles/EventDetails.css";
import { HTMLContent } from "../HTMLContent";
import { LanguageContext } from "../../App";
import TEXT from "../../data/text";

const EventDetails = ({ eventDetailsData }) => {
  const {
    status,
    startFDate,
    endFDate,
    imageUrl,
    description,
    location,
    eventDescImage,
    eventFaq,
    eventTermsCondition,
    eventMailId,
    ionEventUrl,
    ionEventId,
  } = eventDetailsData;
  const { language } = useContext(LanguageContext);
  const handleParticipate = async (e) => {
    e.preventDefault();
    const ionUrl = await ionEventUrl;
    const ionId = await ionEventId;
    window.open(
      ionUrl && ionEventId
        ? `${ionUrl}?${ionId}`
        : ionUrl
        ? `${ionUrl}`
        : window.location.reload()
    );
  };
  return (
    <div className="main_event_detail">
      <div className="event_details_section et_pb_with_background et_section_regular section_has_divider et_pb_bottom_divider">
        <div className="details_main_row row1 details_sub_row_1">
          <div className="column1 et_pb_column_1_3 et_pb_column_1 css_mix_blend_mode_passthrough">
            <div className="module et_pb_image et_pb_image_0">
              <span className="et_pb_image_wrap ">
                <div>
                  <img loading="lazy" alt="" height="auto" src={imageUrl} />
                </div>
              </span>
            </div>
            <div className="details_left_module  et_pb_text et_pb_text_2 et_pb_bg_layout_light">
              <div className="et_pb_text_inner">
                <p>
                  <strong>{TEXT[language]["EVENTDETAILS"]["0"]}</strong>&nbsp;
                  {moment(startFDate).format("Do MMM, YYYY") === "Invalid date"
                    ? startFDate
                    : moment(startFDate).format("Do MMM, YYYY")}
                </p>
                <p>
                  <strong>{TEXT[language]["EVENTDETAILS"]["6"]}</strong>&nbsp;
                  {moment(endFDate).format("Do MMM, YYYY") === "Invalid date"
                    ? endFDate
                    : moment(endFDate).format("Do MMM, YYYY")}
                </p>
                <p>
                  <strong>{TEXT[language]["EVENTDETAILS"]["1"]}&nbsp; </strong>
                  {location}
                </p>
              </div>
            </div>

            {status === "ongoing" && (
              <div className=" details_button_margin">
                <a
                  className="sustainathon_anim_button sustainathon_button_padding"
                  href="#"
                  onClick={(e) => handleParticipate(e)}
                >
                  <span>{TEXT[language]["EVENTDETAILS"]["2"]}</span>
                </a>
              </div>
            )}
            <div className="module details_left_module et_pb_text et_pb_text_3  et_pb_bg_layout_light">
              <div className="et_pb_text_inner">
                <p>
                  <em>
                    {TEXT[language]["EVENTDETAILS"]["3"]}{" "}
                    <a
                      style={{
                        fontWeight: "bold",
                      }}
                      href={`mailto:${eventMailId}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {eventMailId}
                    </a>{" "}
                  </em>
                </p>
                <p>
                  <em>
                    {TEXT[language]["EVENTDETAILS"]["7"]}
                    <span
                      style={{
                        cursor: "pointer",
                        color: "blue",
                        textDecoration: "none",
                      }}
                      onClick={() => {
                        window.open(`${eventFaq}`);
                      }}
                    >
                      {" "}
                      &nbsp;{TEXT[language]["EVENTDETAILS"]["4"]}
                    </span>
                  </em>
                </p>
                <p>
                  <em>
                    {TEXT[language]["EVENTDETAILS"]["5"]}
                    <span
                      style={{
                        cursor: "pointer",
                        color: "blue",
                        textDecoration: "none",
                      }}
                      onClick={() => {
                        window.open(`${eventTermsCondition}`);
                      }}
                    >
                      {" "}
                      &nbsp;{TEXT[language]["EVENTDETAILS"]["4"]}
                    </span>
                  </em>
                </p>
              </div>
            </div>
          </div>{" "}
          <div className="column1 et_pb_column_2_3 et_pb_column_2  css_mix_blend_mode_passthrough et-last-child">
            <div className="module et_pb_text main_desc et_pb_bg_layout_light">
              <div className="text_inner">
                <HTMLContent
                  className="all_event_details"
                  content={description}
                />
              </div>
            </div>{" "}
            {eventDescImage ? (
              <div className="detail_img_row">
                <div className="event_details_img">
                  <img
                    className="responsive-image"
                    src={eventDescImage}
                    alt="details_Image"
                  />
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventDetails;
